


import React, { Component } from 'react';

import DashboardWidget from '../../components/DashboardWidget/DashboardWidget';
import dashboardData from './Dashboarddata';
import { Button } from 'primereact/button';
import ActionWidget from '../../components/DashboardWidget/Actionwidget';
import './InventoryDashboard.scss';
// import RawMaterialTable from '../../components/RawMaterialTable';

class InventoryDashboard extends Component {

    handleFilterChange = (widgetId, value) => {
        this.setState(prevState => ({
            filters: {
                ...prevState.filters,
                [widgetId]: value
            }
        }));
    };

    render() {
        return (
            <div className="invanalytics">

                <div className="p-grid">

                    {/* LEFT COLUMN */}
                        {/* <RawMaterialTable /> */}
                    <div className="p-col-12 p-lg-4">

                        {/* <DashboardWidget title="Key Statistics" className="widget-sm">
                            Key Statistics Content
                        </DashboardWidget> */}
                        <DashboardWidget
                            title="Key Statistics"
                            className="widget-sm"
                            chartType={dashboardData.keyStatistics.chartType}
                            chartData={dashboardData.keyStatistics.data}
                        />
                    {/* <DashboardWidget
                        title="New Purchase"
                        className="widget-lg"
                        chartType={dashboardData.newPurchase.chartType}
                        chartData={dashboardData.newPurchase.data}
                    /> */}
                    <DashboardWidget
                        title="New Purchase"
                        chartType={dashboardData.newPurchase.chartType}
                        chartData={dashboardData.newPurchase.data}
                        filterOptions={[
                                { label: 'Today', value: 'today' },
                                { label: 'Week', value: 'week' },
                                { label: 'Month', value: 'month' }
                            ]}
                            selectedFilter="today"
                        onFilterChange={this.handleFilterChange}
                        showViewButton
                        onViewClick={() => alert('View New Purchase Details')}
                    />

                        <div className="p-grid">

                            <div className="p-col-12 p-md-6">
                                {/* <DashboardWidget title="Raw Material" className="widget-sm">
                                    Raw Material Chart
                                </DashboardWidget> */}
                                <DashboardWidget
                        title="Raw Material"
                        chartType={dashboardData.rawMaterial.chartType}
                        chartData={dashboardData.rawMaterial.data}
                        filterOptions={[
                                { label: 'Today', value: 'today' },
                                { label: 'Week', value: 'week' },
                                { label: 'Month', value: 'month' }
                            ]}
                            selectedFilter="today"
                        onFilterChange={this.handleFilterChange}
                        showViewButton
                        onViewClick={() => alert('View Raw Material Details')}
                    />
                            </div>

                            <div className="p-col-12 p-md-6">
                                {/* <DashboardWidget title="Wastage" className="widget-sm">
                                    Wastage Chart
                                </DashboardWidget> */}
                        <DashboardWidget
                        title="Wastage"
                        chartType={dashboardData.wastage.chartType}
                        chartData={dashboardData.wastage.data}
                        filterOptions={[
                                { label: 'Today', value: 'today' },
                                { label: 'Week', value: 'week' },
                                { label: 'Month', value: 'month' }
                            ]}
                            selectedFilter="today"
                        onFilterChange={this.handleFilterChange}
                        showViewButton
                        onViewClick={() => alert('View Wastage Details')}
                    />
                            </div>

                        </div>

                    </div>

                    {/* CENTER COLUMN */}
                    <div className="p-col-12 p-lg-4">

                        {/* <DashboardWidget title="COGS" className="widget-lg">
                            COGS Chart
                        </DashboardWidget> */}

                        <DashboardWidget
                            title="COGS"
                            className="widget-lg"
                            chartType={dashboardData.cogs.chartType}
                            chartData={dashboardData.cogs.data}
                        />

                        <DashboardWidget
                            title="Stock Level"
                            className="widget-md"
                            chartType={dashboardData.stockLevel.chartType}
                            chartData={dashboardData.stockLevel.data}
                            filterOptions={[
                                { label: 'Today', value: 'today' },
                                { label: 'Week', value: 'week' },
                                { label: 'Month', value: 'month' }
                            ]}
                            selectedFilter="today"
                            onFilterChange={this.handleFilterChange}
                        />

                        {/* <DashboardWidget title="Current Stock Price" className="widget-md">
                            Current Stock Price
                        </DashboardWidget> */}
                        <DashboardWidget title="Current Stock Price">
                        <div className="metric-card">
                            <h2>₹ 8,45,000</h2>
                            <p>Total Inventory Value</p>
                        </div>
                    </DashboardWidget>

                    </div>

                    {/* RIGHT COLUMN */}
                    <div className="p-col-12 p-lg-4">

                        <div className="p-grid">

                            <div className="p-col-12 p-md-6">
                                {/* <DashboardWidget title="Pending Purchases" className="widget-sm">
                                    Pending Purchases
                                </DashboardWidget> */}
                                <DashboardWidget
                                title="Pending Purchases"
                                className="widget-sm"
                            >
                                <h2>14</h2>
                                <p>₹ 1,82,400</p>
                            </DashboardWidget>
                            </div>

                            <div className="p-col-12 p-md-6">
                                {/* <DashboardWidget title="Pending PO Approvals" className="widget-sm">
                                    Pending PO Approvals
                                </DashboardWidget> */}
                                <DashboardWidget
                                    title="Pending Approvals"
                                    className="widget-lg"
                                >
                                    <ActionWidget
                                        data={dashboardData.pendingPOApprovals}
                                        buttonLabel="Approve"
                                        onActionClick={this.handleApprove}
                                    />
                                </DashboardWidget>
                            </div>

                        </div>

                        {/* <DashboardWidget title="PO Raise" className="widget-lg">
                            PO Raise
                        </DashboardWidget> */}
                        <DashboardWidget
                            title="PO Raise"
                            className="widget-lg"
                        >
                            <ActionWidget
                                data={dashboardData.poRaise}
                                buttonLabel="Raise PO"
                                onActionClick={this.handleRaisePO}
                            />
                        </DashboardWidget>

                    </div>

                </div>

                {/* Bottom Full Width Section */}
                {/* <DashboardWidget
                    title="Consumption Comparison"
                    className="widget-md"
                >
                    Consumption Comparison
                </DashboardWidget> */}
                <DashboardWidget
                title="Consumption Comparison"
                className="widget-md"
            >
                <div>
                    <p>
                        Current :
                        {dashboardData.consumptionComparison.currentMonth}
                    </p>

                    <p>
                        Previous :
                        {dashboardData.consumptionComparison.previousMonth}
                    </p>

                    <p>
                        Variance :
                        {dashboardData.consumptionComparison.variance}
                    </p>

                    <p>
                        Top Item :
                        {dashboardData.consumptionComparison.topConsumedItem}
                    </p>
                </div>
            </DashboardWidget>

            </div>
        );
    }
}

export default InventoryDashboard;